function handleAuthFlow() {
    const customer = window.shopifyCustomer;
    const token = localStorage.getItem("token");
    const apiUrl = window.shopifyConfig.apiUrl;
    const storeApiUrl = window.shopifyConfig.storeUrl;
    const storeAccessToken = window.shopifyConfig.storefrontAccessToken;
    // Customer logged in but token missing
    if (customer && customer.id && !token) {
        // console.log("Shopify Customer Object:", window.shopifyCustomer);
        // console.log("Customer logged in but Drupal token missing");
        showLoader();
        const formData = new FormData();
        formData.append("api", "shopifyAPILoginNew");
        formData.append("email", customer.email);
        formData.append("customer_id",customer.id);

        fetch(apiUrl, {
            method: "POST",
            headers: {
                "Store-Front-Url": storeApiUrl,
                "Shopify-Access-Token": storeAccessToken,
            },
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 1){
              const roles = data.profile.roles[0];
              localStorage.setItem("isLoggedIn", "true");
              localStorage.setItem("shopifyEmail", customer.email);
              localStorage.setItem("token", data.access_token);
              localStorage.setItem("userRoles", roles);
            } else {
              throw new Error(data.message || "Invalid login credentials.");
            }
        })
        .catch(error => {
            console.error("Error during login:", error);
            bsAlert(error.message || "An error occurred during login.");
        }).finally(() => {
          hideLoader();
        });
    }else if (!customer && token){
      const shopifyEmail = localStorage.getItem('shopifyEmail');
      console.log("Shopify logout detected → clearing localStorage and cart");
      
      const formData = new FormData();
      formData.append("api", "shopifyAPILogout");
      formData.append("user_email", shopifyEmail);
      formData.append("action", "logout");
      
      showLoader();

      // 1. Call Backend API Logout
      const backendLogout = fetch(apiUrl, {
        method: "POST",
        headers: {
          "Drupal-Access-Token": token,
        },
        body: formData,
      }).then(response => response.json());

      // 2. Clear Shopify Cart via AJAX API
      const clearShopifyCart = fetch((window.Shopify?.routes?.root || '/') + 'cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => response.json());

      // Execute both logout requests concurrently
      Promise.allSettled([backendLogout, clearShopifyCart])
      .then((results) => {
        console.log("Logout & Cart Clear completed:", results);
      })
      .catch((error) => {
        console.error("Logout error:", error);
      })
      .finally(() => {
        hideLoader();
        
        // Clear local storage items
        localStorage.setItem("isLoggedIn", "false");
        localStorage.removeItem("token");
        localStorage.removeItem("customerAccessToken");
        localStorage.removeItem("shopifyEmail");
        localStorage.removeItem("userRoles");
        localStorage.removeItem("recipeOrder");
        localStorage.removeItem('contributorsOrder');
        localStorage.removeItem('photoOrder');
        localStorage.removeItem('lastSavedOrder');

        // Optional: Refresh or redirect so cart UI updates immediately across all tabs
        window.location.reload();
      });
    }else if (customer && customer.id && token) {
        console.log("Customer and token already present");
    }
};
//Normal Flow
document.addEventListener("DOMContentLoaded", handleAuthFlow);

// CRITICAL: Handles Shopify redirect / cache
// window.addEventListener("pageshow", handleAuthFlow);
